import { Clock, BadgeCheck, MessageSquare, ShieldCheck } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";

const CARDS = [
    {
        icon: Clock,
        title: "Available 24/7",
        text: "Locked out late at night or early in the morning? We're available around the clock for emergency locksmith assistance.",
    },
    {
        icon: BadgeCheck,
        title: "Professional Service",
        text: "We approach every job carefully and professionally, from simple lock repairs to more complex security needs.",
    },
    {
        icon: MessageSquare,
        title: "Clear Communication",
        text: "We explain the service before getting started so you know what to expect.",
    },
    {
        icon: ShieldCheck,
        title: "Your Security Matters",
        text: "We treat your home, vehicle, business, and property with care and respect.",
    },
];

export const Trust = () => (
    <section data-testid="trust-section" className="bg-white py-20 sm:py-24 lg:py-28">
        <div className="mx-auto w-full max-w-7xl px-5 sm:px-8">
            <SectionHead
                eyebrow="Why Regina Calls Us"
                title="A Locksmith You Can Feel Confident Calling"
                text="When you're locked out or dealing with a security problem, you want someone dependable. We provide professional locksmith services with a focus on clear communication, quality workmanship, and treating every customer and property with respect."
                testId="trust-heading"
            />
            <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
                {CARDS.map((c, i) => (
                    <Reveal key={c.title} delay={i * 0.1}>
                        <div
                            data-testid={`trust-card-${i + 1}`}
                            className="group h-full rounded-2xl border border-slate-200 bg-white p-7 transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1.5 hover:border-gold/40 hover:shadow-xl hover:shadow-navy-950/5"
                        >
                            <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-gold/10 text-gold-dark transition-colors duration-300 group-hover:bg-gold group-hover:text-navy-950">
                                <c.icon className="h-6 w-6" />
                            </span>
                            <h3 className="mt-5 font-display text-xl font-semibold text-slate-900">{c.title}</h3>
                            <p className="mt-2.5 text-sm leading-relaxed text-slate-600">{c.text}</p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
